import React, { useEffect, useRef, useState } from 'react';
import { Selection } from '../../../types';
import './ItemInfo.scss';

interface ItemInfoProps {
  selection: Selection;
  priceForMobile?: string; // formatted price to display inline on mobile
}

const ItemInfo: React.FC<ItemInfoProps> = ({ selection, priceForMobile }) => {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const detailsRef = useRef<HTMLSpanElement | null>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const [expanded, setExpanded] = useState(false);

  const computeOverflow = () => {
    const el = detailsRef.current;
    if (!el) return;
    // Compare scroll vs client height to determine overflow
    const overflow = el.scrollHeight > el.clientHeight + 1; // tolerance
    setIsOverflowing(overflow);
  };

  useEffect(() => {
    computeOverflow();
    window.addEventListener('resize', computeOverflow);
    return () => window.removeEventListener('resize', computeOverflow);
  }, [selection]);

  const selectionGroupsText = selection.selection_groups.length > 0
    ? selection.selection_groups
        .flatMap((sg: any) => sg.selected_items.map((sgi: any) => sgi.item_name))
        .join(', ')
    : '';

  const modifiersText = selection.modifiers.length > 0
    ? selection.modifiers.map((mod: any) => mod.option_name).join(', ')
    : '';

  const hasDetails = selectionGroupsText || modifiersText;

  return (
    <div className={"item-info" + (expanded ? ' expanded' : '')} ref={containerRef}>
      <div className="item-header">
        <span className="selection-name">
          {selection.item_name}
          {priceForMobile && (
            <span className="mobile-inline-price"> ({priceForMobile})</span>
          )}
        </span>
        {selection.payed && (
          <span className="payed-tag">Pagado</span>
        )}
      </div>
      {hasDetails && (
        <span
          className={"concise-details" + (expanded ? ' show-all' : '')}
          ref={detailsRef}
        >
          {selectionGroupsText}
          {selectionGroupsText && modifiersText && ', '}
          {modifiersText}
        </span>
      )}
      {selection.comment && (
        <span className={"selection-comment" + (expanded ? ' show-all' : '')}>{selection.comment}</span>
      )}
      {isOverflowing && (
        <button
          type="button"
          className="toggle-more"
          onClick={() => setExpanded(e => !e)}
        >
          {expanded ? 'ver menos' : 'ver más'}
        </button>
      )}
    </div>
  );
};

export default ItemInfo;
